import { useQuery } from 'react-query';
import { useMemo } from 'react';
import moment from 'moment';
import {
  DASHBOARD_ENT_LAST_MONTHS_QUERY_KEY,
  queryDashboardENTLastMonths,
} from './DashboardENTLastMonths.query';

export default () => {
  const { data } = useQuery(DASHBOARD_ENT_LAST_MONTHS_QUERY_KEY, () =>
    queryDashboardENTLastMonths()
  );

  const stats = useMemo(
    () =>
      [...Array(6)].map((_, index) => {
        const [month, year] = moment().subtract(index, 'month').format('M,Y').split(',');
        return (
          data?.find((item) => item.month === parseInt(month) && item.year === parseInt(year))
            ?.count || 0
        );
      }),
    [data]
  );

  return (
    <section className="dashboard__sellers">
      <div className="dashboard__sellers-title-header">
        <span className="dashboard__sellers-title">6 derniers mois</span>
      </div>
      <table className="dashboard__sellers-table">
        <thead>
          <tr>
            <th>Mois</th>
            <th>Consultations</th>
          </tr>
        </thead>
        <tbody>
          {stats?.map((_, index) => {
            return (
              <tr key={index}>
                <td style={{ textTransform: 'capitalize' }}>
                  {moment().subtract(index, 'month').format('MMMM')}
                </td>
                <td className={`performance`}>{stats[index]}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </section>
  );
};
